import { render, staticRenderFns } from "./ProductGroups.Vue?vue&type=template&id=b83db3c0"
import script from "./ProductGroups.Vue?vue&type=script&lang=js"
export * from "./ProductGroups.Vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/ProductGroups.Vue
// module id = 194
// module chunks = 0